module.exports = new __parcel__URL__("closed-ja.65224cb2.webp").toString();